import { useState } from 'react';
import chatBubbleIcon from '../../../assets/chatBubbleIcon.svg';
import chatBubbleCloseIcon from '../../../assets/chatBubbleCloseIcon.svg';
import { ChatAgentFormData } from '../../../interfaces/ChatAgent';
import ChatWindow from './ChatWindow/ChatWindow';
import StyledChatConfigPreview from './StyledChatConfigPreview';
import StyledChatToggle from './StyledChatToggle';

interface ChatConfigPreviewProps {
  formData?: Partial<ChatAgentFormData>;
  startMessage?: string;
  showPromptSuggestions?: boolean;
  showDisclaimer?: boolean;
  activeField?: string;
}

const ChatConfigPreview: React.FC<ChatConfigPreviewProps> = ({
  formData,
  startMessage,
  showPromptSuggestions,
  showDisclaimer = false,
  activeField,
}): JSX.Element => {
  const [message, setMessage] = useState('');
  const isChatOpen = !(activeField === 'bubble_text');

  const handleMessageChange = (value: string) => {
    setMessage(value);
  };

  return (
    <StyledChatConfigPreview>
      {isChatOpen ? (
        <ChatWindow
          message={message}
          onMessageChange={handleMessageChange}
          headerAvatar={formData?.header_avatar_url}
          chatAvatar={formData?.chat_avatar_url}
          themeColor={formData?.theme_color}
          chatTitle={formData?.header_text}
          chatIntro={startMessage}
          promptSuggestions={
            showPromptSuggestions ? formData?.prompt_suggestions : undefined
          }
          disclaimerHtml={
            showDisclaimer
              ? formData?.user_data_prompt_html_disclaimer
              : undefined
          }
        />
      ) : (
        formData?.bubble_text && (
          <div
            style={{
              position: 'absolute',
              bottom: '114px',
              right: 0,
              fontFamily: 'Helvetica, Arial, sans-serif',
            }}
          >
            <div
              style={{
                height: '15px',
                width: '15px',
                position: 'absolute',
                borderRadius: '50%',
                color: '#fff',
                backgroundColor: '#000',
                display: 'flex',
                alignContent: 'center',
                justifyContent: 'center',
                flexWrap: 'wrap',
                top: '-7px',
                left: '-7px',
                fontSize: '8px',
                cursor: 'pointer',
              }}
            >
              x
            </div>
            <div
              style={{
                border: '1px solid #B5B5B5',
                borderRadius: '8px',
                padding: '18px',
                maxWidth: '300px',
                flexShrink: 0,
                backgroundColor: '#fff',
              }}
            >
              {formData.bubble_text}
            </div>
          </div>
        )
      )}
      <StyledChatToggle
        isChatWindowOpen={isChatOpen}
        themeColor={formData?.theme_color}
      >
        {isChatOpen ? (
          <img className="chat-close-icon" src={chatBubbleCloseIcon} alt="" />
        ) : (
          <img className="chat-bubble-icon" src={chatBubbleIcon} alt="" />
        )}
      </StyledChatToggle>
    </StyledChatConfigPreview>
  );
};

export default ChatConfigPreview;
